<template>
    <button
        type="button"
        class="inline-flex px-4 py-2 text-sm font-medium leading-5 transition duration-150 ease-in-out border rounded-full secondary-button-border secondary-button-bg secondary-button-hover-bg secondary-button-hover-border secondary-button-text secondary-button-hover-text focus:outline-none"
        :class="{
            'secondary-button-disabled cursor-not-allowed': disabled,
            'secondary-button-active': active,
        }"
        :disabled="disabled"
    >
        <loading-icon :visible="processing"></loading-icon>
        <slot></slot>
    </button>
</template>

<script>
import LoadingIcon from '@/components/ui/LoadingIcon.vue';
export default {
    components: {
        LoadingIcon,
    },

    props: {
        disabled: {
            default: false,
        },

        active: {
            default: false,
        },

        processing: {
            default: false,
        },
    },
};
</script>
